import { FETCH_TOPICS } from './constants'

export const fetchTopics = {
  request: (deviceId) => ({ type: FETCH_TOPICS.REQUEST, deviceId }),
  success: (topics) => ({ type: FETCH_TOPICS.SUCCESS, topics }),
  failure: () => ({ type: FETCH_TOPICS.FAILURE })
}
